"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Wann darf ich Bäume fällen oder schneiden?",
  answer: "Nach dem Bundesnaturschutzgesetz sind starke Rückschnitte und Fällungen zwischen dem 1. März und 30. September zum Schutz nistender Vögel untersagt. Form- und Pflegeschnitte sowie notwendige Verkehrssicherungsmaßnahmen sind jedoch meist ganzjährig zulässig."
}, {
  question: "Benötige ich in Hamburg oder Schleswig Holstein eine Genehmigung?",
  answer: "In Hamburg und vielen umliegenden Gemeinden wie Ahrensburg greift die Baumschutzverordnung. Wir prüfen für Sie vorab, ob Ihr Baum geschützt ist, und unterstützen Sie kompetent bei der Einholung notwendiger Genehmigungen."
}, {
  question: "Was kostet eine professionelle Baumpflege oder Fällung?",
  answer: "Die Kosten variieren je nach Baumart, Größe, Standort und gewählter Technik (z.B. Seilklettertechnik). Wir bieten Ihnen eine kostenlose Erstbesichtigung an, um Ihnen ein faires und transparentes Festpreisangebot zu erstellen."
}, {
  question: "Wie sicher ist die Arbeit an Gebäuden oder engen Standorten?",
  answer: "Sicherheit ist unsere oberste Priorität. Durch den Einsatz moderner Seilklettertechnik (SKT) können wir selbst über Wintergärten oder an engen Grundstücksgrenzen zentimetergenau arbeiten, ohne Ihr Eigentum zu gefährden."
}, {
  question: "Bieten Sie eine kostenlose Einschätzung vor Ort an?",
  answer: "Ja, wir besuchen Sie in Hamburg, Ahrensburg und Umgebung für eine unverbindliche Erstbesichtigung. Wir besprechen die Situation direkt am Baum und geben Ihnen eine fachliche Einschätzung zu Pflegebedarf oder Standsicherheit."
}];
export default function CommonInquiries() {
  return <section data-section-id="221681" id="häufige-fragen-zur-pflege" className="text-foreground py-24 px-6 relative overflow-hidden !bg-[rgba(245,244,241,1)] md:px-12 lg:px-24">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-3xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold font-default mb-4 tracking-tight">
            Häufige Fragen zur Pflege
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto font-default">
            Wichtige Informationen zu Schnittverboten, Genehmigungen und dem Ablauf unserer Arbeiten in der Region Hamburg.
          </p>
        </div>

        {}
        <div className="bg-card border border-border/50 rounded-2xl p-6 md:p-8 shadow-xl shadow-shadow-color/5 backdrop-blur-md">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 py-2">
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold font-default hover:text-primary transition-colors hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed font-default pt-2 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}